import { createSelector } from 'reselect'
import type { ReduxState } from '@/utils/typeHelpers'

const selectAdviserChatState = (state: ReduxState) => state.adviserChat

export const selectPanelOpen = createSelector(
  selectAdviserChatState,
  (s) => s.panelOpen
)

export const selectActiveView = createSelector(
  selectAdviserChatState,
  (s) => s.activeView
)

export const selectActiveConversationId = createSelector(
  selectAdviserChatState,
  (s) => s.activeConversationId
)

export const selectConversations = createSelector(
  selectAdviserChatState,
  (s) => s.conversations
)

export const selectConversationViews = createSelector(
  selectAdviserChatState,
  (s) => s.conversationViews
)

export const selectNeedsAttentionCount = createSelector(
  selectAdviserChatState,
  (s) => s.needsAttentionCount
)

export const selectHasMoreConversations = createSelector(
  selectAdviserChatState,
  (s) => s.hasMoreConversations
)

export const selectConversationsLoaded = createSelector(
  selectAdviserChatState,
  (s) => s.conversationsLoaded
)

export const selectPendingLaunchContext = createSelector(
  selectAdviserChatState,
  (s) => s.pendingLaunchContext
)

export const selectPendingEntryPoint = createSelector(
  selectAdviserChatState,
  (s) => s.pendingEntryPoint
)

export const selectActiveLaunchAction = createSelector(
  selectAdviserChatState,
  (s) => s.activeLaunchAction
)

export const selectActiveEntryPoint = createSelector(
  selectAdviserChatState,
  (s) => s.activeEntryPoint
)

export const selectMessagesListTab = createSelector(
  selectAdviserChatState,
  (s) => s.messagesListTab
)

export const selectActiveThreadId = createSelector(
  selectAdviserChatState,
  (s) => s.activeThreadId
)
